import { combineReducers } from 'redux';
import ApplicantDetailsReducer from './applicantDetailsReducer';
import OtherQualificationsReducer from './otherQualificationsReducer';
import MailingAddressReducer from './mailingAddressReducer';
import UserIdReducer from './userIdReducer';
import CategoriesReducer from './categoriesReducer';
import SelectedCategoriesReducer from './selectedCategoriesReducer';
import ScreensReducer from './screensReducer';
import SignatureReducer from './signatureReducer';
import Apireducer from './apiReducer';

export default combineReducers({
  ApplicantData: ApplicantDetailsReducer,
  QualificationsData: OtherQualificationsReducer,
  MailingAddressData: MailingAddressReducer,
  UserIdData: UserIdReducer,
  CategoriesData: CategoriesReducer,
  SelectedCategoriesData: SelectedCategoriesReducer,
  ScreensData: ScreensReducer,
  SignatureData: SignatureReducer,
  ApiData: Apireducer,
});
